<template>
  <div class="loading" v-if="loading">
    <img src="../assets/loading.gif" />
  </div>
  <div :class="[loading ? 'l-modal__bg' : '']"></div>
  <div class="draft">
    <p v-show="mediaType != MEDIA_TYPE.YOUTUBE">投稿予定文章</p>
    <p v-show="mediaType == MEDIA_TYPE.YOUTUBE">
      限定公開で投稿した動画のURLを入力してください
    </p>
    <textarea
      v-model="content"
      :class="[
        mediaType != MEDIA_TYPE.YOUTUBE ? 'draft-text-area' : 'url-area',
      ]"
      required
      :placeholder="setPlaceholder()"
    ></textarea>
    <div class="button-area">
      <common-button
        :data="{
          status: content && FileListUploaded() ? 0 : 2,
          button: !FileListUploaded()
            ? `ファイルアップロード中 ${
                projectStore.fileUploadResult.length
              } / ${
                projectStore.fileUploadList.get(projectStore.selectedId)?.length
              }`
            : `下書きを送信する`,
        }"
        @click="content && FileListUploaded() ? sendDraft() : ''"
        v-if="mediaType != MEDIA_TYPE.YOUTUBE"
      ></common-button>
      <common-button
        :data="{
          status: content ? 0 : 2,
          button: `下書きを送信する`,
        }"
        @click="content ? sendDraft() : ''"
        v-else
      ></common-button>
    </div>
    <div class="upload_progress">
      <div
        class="upload_progress_img_wrap"
        v-for="(file, index) in projectStore.fileUploadList.get(
          projectStore.selectedId
        )"
        :key="index"
      >
        <img :src="file.display" />
        <img
          src="../assets/banner-success.svg"
          class="uploaded_img"
          v-if="index < projectStore.fileUploadResult.length"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { useRoute, useRouter } from "vue-router";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import { MEDIA_TYPE } from "../consts/common";
// import Toast from "./Toast.vue";

const content = ref("");
const projectStore = ProjectStore();
const commonStore = CommonStore();
const router = useRouter();
const route = useRoute();
// const FileListUploaded = ref(false)
const mediaType = ref(0);
const loading = ref(false);
const files = ref(new Array<number>());
const fileAllUploadedFlag = ref(false);

onMounted(() => {
  mediaType.value = route.query.mediaType ? +route.query.mediaType : 0;
  // 下書き再提出の場合は前回入力分の下書き内容を反映する
  // content.value = String(route.query.content || '')
  content.value = projectStore.draftBeforeChecked;
  // if (!content.value) {
  //   content.value = String(route.query.hashtag|| '')
  // }

  if (mediaType.value != MEDIA_TYPE.YOUTUBE) {
    commonStore.setToast({
      showToast: true,
      message: `ファイルアップロード中です `,
      state: 0,
    });
  } else {
    fileAllUploadedFlag.value = true;
  }
});
onBeforeUnmount(() => {
  // ファイルアップロード中にブラウザバックした場合、アップロード済のファイルをstoreから削除、API通信とめる
  // 「ファイルアップロード中です」トースター非表示にする
  if (!fileAllUploadedFlag.value) {
    projectStore.setBackToUploadFile(true);
    commonStore.setToast({
      showToast: false,
      message: "ファイルアップロードを中止しました",
      timeout: 1000,
      state: 0,
    });
    // 全てアップロード済だった場合はfalseにする
    projectStore.setFileAllUploaded(false);
    // 結果リセット
    projectStore.resetFileUploadResult();
  }
});
async function sendDraft() {
  loading.value = true;
  projectStore.fileUploadResult.forEach(async(v) => {
     files.value.push(v.id);
  });

  const url = mediaType.value == MEDIA_TYPE.YOUTUBE ? content.value : "";
  // 下書きを送信する
  await projectStore
    .sendDraft({ content: content.value, resources: files.value, url: url })
    .then((v) => {
      loading.value = false;
      if (!v) return;
      projectStore.setDraftBeforeChecked("");
      if (mediaType.value != MEDIA_TYPE.YOUTUBE) {
        router.go(-2);
      } else {
        router.go(-1);
      }
    });
}

function setPlaceholder(): string {
  if (mediaType.value == MEDIA_TYPE.YOUTUBE) {
    return "https://youtube.com/";
  } else {
    return "投稿予定文章";
  }
}
function FileListUploaded() {
  // youtubeの場合はファイルアップロードなないためtrue
  if (route.query.mediaType) {
    return true;
  } else if (!route.query.mediaType && projectStore.fileAllUploaded) {
    if (fileAllUploadedFlag.value) return true;
    commonStore.setToast({
      showToast: false,
      message: "ファイルアップロード中です",
      timeout: 100,
      state: 0,
    });
    commonStore.setToast({
      showToast: true,
      message: "ファイルアップロード完了しました",
      timeout: 2000,
      state: 0,
    });
    fileAllUploadedFlag.value = true;
    return true;
  } else if (
    window.history.state.back == "/upload-file" &&
    !projectStore.fileAllUploaded
  ) {
    return false;
  }
}
</script>
<style scoped lang="scss">
@import "../assets/style/_variables.scss";
.draft {
  text-align: center;
}
.loading {
  display: flex;
  position: absolute;
  justify-content: center;
  top: 50%;
  z-index: 9999;
  img {
    width: 10%;
    height: 10%;
  }
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
.image-upload > input {
  display: none;
}
.add-file {
  display: block;
  margin-left: 40px;
  margin-bottom: 24px;
}
.dialog-error-message {
  color: red;
}
.draft-text-area {
  width: 295px;
  height: 400px;
  padding-left: 8px;
  padding-top: 8px;
  margin: auto;
  overflow-y: auto;
}
.url-area {
  width: 335px;
  max-height: 48px;
  padding-left: 10px;
  padding-top: 13px;
  margin: auto;
  overflow-y: auto;
}
.btn-contact {
  margin-right: 10px;
  width: 200px;
  appearance: none;
  border: 0;
  border-radius: 5px;
  background: #0074ff;
  color: $white;
  padding: 8px 12px;
  font-size: $FONT_SIZE_M;
}
.btn-close {
  margin-right: 10px;
  width: 70px;
  appearance: none;
  border: 0;
  border-radius: 5px;
  background: #b2b2b2;
  color: $white;
  padding: 8px 12px;
  font-size: $FONT_SIZE_M;
}
.draft {
  p:nth-child(1) {
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_M;
    line-height: 18px;
    padding-top: 20px;
    color: #000000;
  }
  p:nth-child(2) {
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_M;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
  }
}
.button-area {
  width: 100%;
  max-width: 480px;
  height: 56px;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
}
.upload_progress {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  justify-content: center;
  // width: fit-content;
  // justify-content: space-evenly;
  .upload_progress_img_wrap {
    position: relative;
    min-width: 80px;
    min-height: 80px;
    max-width: 80px;
    max-height: 80px;
    margin: 0 5px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .uploaded_img {
    position: absolute;
    display: block;
    right: 0px;
    top: 0px;
    width: 15px;
    height: 15px;
    padding: 5px;
    /* border: 1px solid #e0e0e0; */
    background: #e0e0e0;
  }
}

.upload_progress::-webkit-scrollbar {
  display: none;
}
</style>
